(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-benefits-bar]');

    for (const root of roots) {
      if (root.dataset.initialized === 'true') {
        continue;
      }

      root.dataset.initialized = 'true';
    }

    if (!document.querySelector('[data-benefits-bar][data-has-lucide="true"]')) {
      return;
    }

    const loadLucide = () => {
      if (window.lucide && typeof window.lucide.createIcons === 'function') {
        return Promise.resolve(window.lucide);
      }

      if (window.__benefitsBarLucidePromise) {
        return window.__benefitsBarLucidePromise;
      }

      window.__benefitsBarLucidePromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/lucide@latest';
        script.async = true;
        script.onload = () => resolve(window.lucide);
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window.__benefitsBarLucidePromise;
    };

    loadLucide()
      .then((lucide) => {
        if (lucide && typeof lucide.createIcons === 'function') {
          lucide.createIcons({ attrs: { width: 32, height: 32 } });
        }
      })
      .catch(() => {
        /* no-op */
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class PfPopup {
      constructor(root) {
        this.popup = root.querySelector('[data-pf-popup]');
        this.overlay = root.querySelector('[data-pf-overlay]');
        this.closeBtn = root.querySelector('[data-pf-close]');
        this.bubble = root.querySelector('[data-pf-bubble]');

        if (!this.popup || !this.overlay) return;

        this.autoOpen  = this.popup.dataset.autoOpen === 'true';
        this.delay     = (parseFloat(this.popup.dataset.delay) || 0) * 1000;
        this.frequency = this.popup.dataset.frequency || 'once_per_session';
        this.sectionId = this.popup.dataset.sectionId || 'popup';

        this.lsKey = `pf-popup-closed-${this.sectionId}`;
        this.ssKey = `pf-popup-session-${this.sectionId}`;

        this._focusable = null;
        this._resizeScheduled = false;

        this._bindEvents();
        this._init();
      }

      _init() {
        if (this.autoOpen && this._shouldShow()) {
          setTimeout(() => this.open(), this.delay);
        } else {
          this._showBubble();
        }
      }

      _showBubble() {
        this.bubble?.classList.add('is-visible');
      }

      _hideBubble() {
        this.bubble?.classList.remove('is-visible');
      }

      _shouldShow() {
        switch (this.frequency) {
          case 'always':
            return true;
          case 'once_per_session':
            return !sessionStorage.getItem(this.ssKey);
          case 'once_per_day': {
            const last = localStorage.getItem(this.lsKey);
            if (!last) return true;
            return Date.now() - parseInt(last, 10) > 24 * 60 * 60 * 1000;
          }
          case 'once_per_week': {
            const last = localStorage.getItem(this.lsKey);
            if (!last) return true;
            return Date.now() - parseInt(last, 10) > 7 * 24 * 60 * 60 * 1000;
          }
          default:
            return true;
        }
      }

      _saveClose() {
        localStorage.setItem(this.lsKey, Date.now().toString());
        sessionStorage.setItem(this.ssKey, '1');
      }

      open() {
        this.popup.setAttribute('aria-hidden', 'false');
        this.overlay.setAttribute('aria-hidden', 'false');
        this.popup.classList.add('is-open');
        this.overlay.classList.add('is-open');

        document.body.style.overflow = 'hidden';
        this._hideBubble();

        this._focusable = this.popup.querySelectorAll(
          'a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])'
        );
        if (this._focusable.length) {
          this._focusable[0].focus();
        }

        this._layoutOverlayImages();
        this._layoutSliderArrows();
      }

      _layoutSliderArrows() {
        const sliders = Array.from(this.popup.querySelectorAll('.pf-popup__products-slider'));
        sliders.forEach((slider) => {
          const media = slider.querySelector('.card__media');
          if (!media) return;
          const height = media.getBoundingClientRect().height;
          if (height > 0) {
            slider.style.setProperty('--pf-slider-arrow-top', `${Math.round(height / 2)}px`);
          }
        });
      }

      _layoutOverlayImages() {
        const medias = Array.from(this.popup.querySelectorAll('[data-pf-overlay-image]'));
        if (!medias.length) return;

        medias.forEach((media) => {
          media.style.height = '';
        });

        const totalHeight = this.popup.scrollHeight;

        medias.forEach((media) => {
          const naturalHeight = media.getBoundingClientRect().height;
          const rest = totalHeight - naturalHeight;
          const target = rest > 40 ? (0.4 / 0.6) * rest : window.innerHeight * 0.4;
          media.style.height = `${Math.round(target)}px`;
        });
      }

      close() {
        this.popup.setAttribute('aria-hidden', 'true');
        this.overlay.setAttribute('aria-hidden', 'true');
        this.popup.classList.remove('is-open');
        this.overlay.classList.remove('is-open');
        document.body.style.overflow = '';

        this._saveClose();
        this._showBubble();
      }

      _trapFocus(e) {
        if (!this._focusable || !this._focusable.length) return;
        const first = this._focusable[0];
        const last  = this._focusable[this._focusable.length - 1];

        if (e.key === 'Tab') {
          if (e.shiftKey) {
            if (document.activeElement === first) {
              e.preventDefault();
              last.focus();
            }
          } else {
            if (document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        }
      }

      _bindEvents() {
        this.closeBtn?.addEventListener('click', () => this.close());
        this.overlay?.addEventListener('click', () => this.close());
        this.bubble?.addEventListener('click', () => this.open());

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.popup.classList.contains('is-open')) {
            this.close();
          }
          if (this.popup.classList.contains('is-open')) {
            this._trapFocus(e);
          }
        });

        window.addEventListener('resize', () => {
          if (!this.popup.classList.contains('is-open') || this._resizeScheduled) return;
          this._resizeScheduled = true;
          requestAnimationFrame(() => {
            this._resizeScheduled = false;
            this._layoutOverlayImages();
            this._layoutSliderArrows();
          });
        });

        this.popup.addEventListener('click', (e) => e.stopPropagation());
      }
    }

    document.querySelectorAll('[data-pf-popup]').forEach((popupEl) => {
      const root = popupEl.closest('.shopify-section') || document;
      if (root.dataset.pfPopupInitialized === 'true') return;
      root.dataset.pfPopupInitialized = 'true';
      new PfPopup(root);
    });

    if (document.querySelector('[data-pf-bubble] [data-lucide]')) {
      const loadLucide = () => {
        if (window.lucide && typeof window.lucide.createIcons === 'function') {
          return Promise.resolve(window.lucide);
        }

        if (window.__pfPopupLucidePromise) {
          return window.__pfPopupLucidePromise;
        }

        window.__pfPopupLucidePromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://unpkg.com/lucide@latest';
          script.async = true;
          script.onload = () => resolve(window.lucide);
          script.onerror = reject;
          document.head.appendChild(script);
        });

        return window.__pfPopupLucidePromise;
      };

      loadLucide()
        .then((lucide) => {
          if (lucide && typeof lucide.createIcons === 'function') {
            lucide.createIcons({ attrs: { width: 24, height: 24 } });
          }
        })
        .catch(() => {
          /* no-op */
        });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-help-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-floating-help]');

    for (const root of roots) {
      if (root.dataset.initialized === 'true') {
        continue;
      }

      root.dataset.initialized = 'true';

      const panel = root.querySelector('.floating-help__panel');
      const toggle = root.querySelector('.floating-help__toggle');
      const closeButton = root.querySelector('.floating-help__close');

      if (!panel || !toggle || !closeButton) {
        continue;
      }

      const setOpen = (isOpen) => {
        panel.classList.toggle('is-open', isOpen);
        panel.setAttribute('aria-hidden', String(!isOpen));
        toggle.setAttribute('aria-expanded', String(isOpen));
        toggle.setAttribute('aria-label', isOpen ? 'Cerrar panel de ayuda' : 'Abrir panel de ayuda');
      };

      toggle.addEventListener('click', () => {
        setOpen(!panel.classList.contains('is-open'));
      });

      closeButton.addEventListener('click', () => {
        setOpen(false);
      });

      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) {
          setOpen(false);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          setOpen(false);
        }
      });
    }

    if (!document.querySelector('[data-floating-help][data-has-lucide="true"]')) {
      return;
    }

    const loadLucide = () => {
      if (window.lucide && typeof window.lucide.createIcons === 'function') {
        return Promise.resolve(window.lucide);
      }

      if (window.__floatingHelpLucidePromise) {
        return window.__floatingHelpLucidePromise;
      }

      window.__floatingHelpLucidePromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/lucide@latest';
        script.async = true;
        script.onload = () => resolve(window.lucide);
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window.__floatingHelpLucidePromise;
    };

    loadLucide()
      .then((lucide) => {
        if (lucide && typeof lucide.createIcons === 'function') {
          lucide.createIcons({ attrs: { width: 24, height: 24 } });
        }
      })
      .catch(() => {
        /* no-op */
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
